import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import CredentialStrip from "@/components/sections/CredentialStrip";
import About from "@/components/sections/About";
import SectionDivider from "@/components/sections/SectionDivider";
import Services from "@/components/sections/Services";
import Treatments from "@/components/sections/Treatments";
import Manifest from "@/components/sections/Manifest";
import FAQ from "@/components/sections/FAQ";
import Testimonials from "@/components/sections/Testimonials";
import InstagramSection from "@/components/sections/InstagramSection";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import WhatsAppFab from "@/components/sections/WhatsAppFab";

const Home = () => {
  return (
    <main className="relative bg-warm-white text-editorial-dark">
      <Navbar />
      <Hero />
      <CredentialStrip />
      <About />
      <SectionDivider label="Servicios" />
      <Services />
      <Treatments />
      <Manifest />
      <FAQ />
      <SectionDivider label="Testimonios" />
      <Testimonials />
      <InstagramSection />
      <Contact />
      <Footer />
      <WhatsAppFab />
    </main>
  );
};

function App() {
  return (
    <div className="App font-sans antialiased">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#F7F3EE",
            color: "#4A4544",
            border: "1px solid rgba(216, 180, 176, 0.5)",
            fontFamily: "Outfit, sans-serif",
            borderRadius: "16px",
          },
        }}
      />
    </div>
  );
}

export default App;
